import React, { useRef } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import {
	ContentTemplate,
	FkTable,
	GeneratedContent,
} from '../../stores/reducers/generate-content';
import { MediaItem } from '../../stores/reducers/media';
import Icon, { ICONS, COLORS } from '../general-components/icon';
import { setSelectedMediaTemplate } from '../../stores/actions/generate-content';
import { TABS } from '../../stores/reducers/session';
import * as SessionActions from '../../stores/actions/session';
import { ROOM_STATES } from '../../stores/reducers/settings';
import { GreenroomState as GS } from '../../stores/types/types';
import { setCurrentGraphicsId } from '../../stores/actions/graphics';
import { nonEditTypes } from '../../utils/content-templates';
import StylePackLoadingSpinner from '../style-packs/style-pack-loading-spinner';

interface VideoHoverOptionsProps {
	className?: string;
	generateContentTemplate?: ContentTemplate;
	mediaItem?: MediaItem;
	isHovering: boolean;
	videoRef?: HTMLVideoElement | null;
}

export default function VideoHoverOptions(props: VideoHoverOptionsProps) {
	const {
		className,
		generateContentTemplate,
		mediaItem,
		isHovering,
		videoRef,
	} = props;

	const dispatch = useDispatch();
	const roomState = useSelector((s: GS) => s.MeetingReducer.roomState);
	const timmy = useRef<NodeJS.Timer | null>(null);
	const [locationData, setLocationData] = React.useState<DOMRect | undefined>(videoRef?.getBoundingClientRect
		? videoRef?.getBoundingClientRect()
		: undefined);

	React.useEffect(() => {
		if (timmy.current) {
			clearInterval(timmy.current);
			timmy.current = null;
		}
		if (!timmy.current) {
			timmy.current = setInterval(() => {
				setLocationData(videoRef?.getBoundingClientRect
					? videoRef?.getBoundingClientRect()
					: undefined);
			}, 100);
		}
		return () => {
			if (timmy.current) {
				clearInterval(timmy.current);
				timmy.current = null;
			}
		};
	}, [videoRef]);

	if (!mediaItem || !locationData || nonEditTypes.includes(generateContentTemplate?.type ?? '')) {
		return (<></>);
	}

	return (
		<div
			className={classNames('video-hover-options', className)}
			style={{
				position: 'absolute',
				top: `${(locationData?.top ?? 0) - 70}px`,
				left: `${locationData?.left}px`,
				bottom: `${locationData?.bottom}px`,
				right: `${locationData?.right}px`,
				width: `${locationData?.width}px`,
				height: `${locationData?.height}px`,
				pointerEvents: 'none',
			}}
		>
			<StylePackLoadingSpinner
				type={FkTable.media}
				id={mediaItem.id}
				isForShotEditorModal={false}
			/>
			<div className={classNames('video-hover-options-buttons', isHovering && 'hover')}>
				{generateContentTemplate && roomState === ROOM_STATES.EDITING && (
					<div
						className="video-hover-options-button"
						onClick={() => {
							if (mediaItem) {
								dispatch(setSelectedMediaTemplate(mediaItem, generateContentTemplate?.type ?? ''));
								dispatch(setCurrentGraphicsId(0));
								dispatch(SessionActions.setRightDrawerOpen(true));
								dispatch(SessionActions.setActiveTab(TABS.GENERATE_MEDIA_CONTENT));
							}
						}}
					>
						<Icon
							name={ICONS.EDIT}
							color={COLORS.WHITE}
							size={12}
						/>
					</div>
				)}
			</div>
		</div>
	);
}
